/* import __COLOCATED_TEMPLATE__ from './npm.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';

interface Args {
  appIdCode: string;
  createdAt: string;
  email: string;
  name: string;
  selectedInstallationMethod: string;
  selectedUserIdentifier: string;
  userHash: string;
  userID: string;
}

interface Signature {
  Element: HTMLElement;
  Args: Args;
}

export default class Npm extends Component<Signature> {
  @service declare intercomEventService: $TSFixMe;

  @action
  onCopyCode() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'copy_code_snippet',
      metadata: {
        is_idv: true,
        identifier: this.args.selectedUserIdentifier,
        app_type: `npm-${this.args.selectedInstallationMethod}`,
      },
      place: 'installation-new',
      section: 'settings',
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'InstallationNew::Web::IdvSetup::CodeSnippets::UpdateSite::Npm': typeof Npm;
    'installation-new/web/idv-setup/code-snippets/update-site/npm': typeof Npm;
  }
}
